<template>
  <span
    ><span v-for="(n, index) in dice.action" :key="index + '-action'" class="icon"
      ><i class="fas fa-dice-d6"></i></span
    ><span
      v-for="(n, index) in dice.power"
      :key="index + '-power'"
      class="icon has-text-danger"
      ><i class="fas fa-dice-d6"></i></span
  ></span>
</template>

<script>
export default {
  name: "DiceBar",
  props: {
    dice: {
      type: Object,
      required: true
    }
  }
};
</script>
